<template>
  <Home />
</template>

<script>
import Home from '../components/home';

export default {
  components: {
    Home,
  },
};
</script>
